var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.total),function(n){return _c('span',{key:n,on:{"click":function($event){return _vm.changePageFn(n)}}},[_vm._v(_vm._s(n))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }